module.exports = __webpack_public_path__ + "img/device_cb04.dde9bc79.png";